module.exports = __webpack_public_path__ + "img/64_3.c4438a34.png";